import Icon from '../components/Icon.vue'

Icon.register({
  frog: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M446.5 97.4C439.7 60.2 407.2 32 368 32 328.8 32 296.3 60.3 289.5 97.5 126.8 113-0.5 250.1 0 417 0.1 451.9 29.1 480 64 480H368C376.8 480 384 472.8 384 464 384 446.3 369.7 432 352 432H272.5L308.3 383.7C332.4 347.4 318.7 295.4 274.6 277.1 250.7 267.1 223.1 272.4 202.4 287.9L169.6 312.5C162.5 317.9 152.5 316.4 147.2 309.4 141.9 302.3 143.3 292.2 150.4 286.9L185.2 260.9C222 233.2 273.4 233.2 310.3 260.9 321.2 269 356.2 299.9 351.1 354.1L469.6 480H560C568.8 480 576 472.8 576 464 576 446.3 561.7 432 544 432H490.4L391.9 327.3 546.3 240.7A58.2-58.2 0 0 1 576 189.9C576 168.5 564.3 149 545.5 138.7 505 116.5 446.5 97.4 446.5 97.4zM368 136C354.7 136 344 125.3 344 112 344 98.7 354.7 88 368 88 381.3 88 392 98.7 392 112 392 125.3 381.3 136 368 136z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/frog.js
// module id = cBXc
// module chunks = 144